import React from "react";
import { colorForKey, initialsOf } from "../../lib/roles";

/**
 * UserAvatar — deterministic gradient + initials for any team member.
 * Used by team page, sidebar, deal participants etc.
 */
export const UserAvatar = ({
  name,
  email,
  size = 36,
  ring = false,
  online = false,
  className = "",
  imgUrl,
}) => {
  const key = email || name || "";
  const [grad] = colorForKey(key);
  const text = initialsOf(name || email);
  const px = `${size}px`;
  const fontSize = `${Math.max(10, Math.round(size * 0.36))}px`;

  return (
    <span
      className={`relative inline-flex shrink-0 ${className}`}
      style={{ width: px, height: px }}
      data-testid={`user-avatar-${key || "anon"}`}
    >
      <span
        className={`flex items-center justify-center rounded-full text-white font-semibold bg-gradient-to-br ${grad} ${ring ? "ring-2 ring-white" : ""}`}
        style={{ width: px, height: px, fontSize, letterSpacing: "0.02em" }}
      >
        {imgUrl ? (
          <img
            src={imgUrl}
            alt={name || email || ""}
            className="w-full h-full object-cover rounded-full"
            loading="lazy"
          />
        ) : (
          text
        )}
      </span>
      {online && (
        <span
          className="absolute bottom-0 right-0 block rounded-full bg-emerald-500 ring-2 ring-white"
          style={{ width: size * 0.28, height: size * 0.28 }}
          aria-hidden
        />
      )}
    </span>
  );
};

export const UserAvatarStack = ({ people = [], max = 4, size = 28 }) => {
  const visible = people.slice(0, max);
  const extra = people.length - visible.length;
  return (
    <div className="flex items-center" data-testid="user-avatar-stack">
      {visible.map((p, i) => (
        <span key={p.id || p.email || i} style={{ marginLeft: i === 0 ? 0 : -8 }}>
          <UserAvatar name={p.full_name || p.name} email={p.email} size={size} ring />
        </span>
      ))}
      {extra > 0 && (
        <span
          className="rounded-full bg-slate-900 text-white flex items-center justify-center text-[10px] font-semibold ring-2 ring-white"
          style={{ width: size, height: size, marginLeft: -8 }}
        >
          +{extra}
        </span>
      )}
    </div>
  );
};
